import type { ReactNode } from 'react';
import { LayerDataContext, useLayerDataSource } from './useLayerData';

interface ILayerDataProviderProps {
  siteId: string;
  children: ReactNode;
}

/**
 * The Monitor page's Activities / Issues layer data, loaded once for the rail
 * list, the building's chips, the special areas and the floor drawer.
 */
export function LayerDataProvider({ siteId, children }: ILayerDataProviderProps) {
  const data = useLayerDataSource(siteId);
  return <LayerDataContext.Provider value={data}>{children}</LayerDataContext.Provider>;
}
